// src/auth.types.ts
var UserRole = {
  AI_ADMIN: "AI_ADMIN",
  STORE_ADMIN: "STORE_ADMIN",
  OPERATOR: "OPERATOR",
  CUSTOMER: "CUSTOMER",
  POS_TERMINAL: "POS_TERMINAL"
};
function isTwoFactorChallenge(res) {
  return res.two_factor_required === true;
}
function isAdminTwoFactorChallenge(res) {
  return res.two_factor_required === true;
}

// src/store.types.ts
var StoreStatus = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  MAINTENANCE: "MAINTENANCE"
};
var Market = {
  /** Ba Lan — vào cửa bằng lượt giữ tiền, trừ tự động ở cổng ra. */
  PL: "PL",
  /** Ukraine — luồng cũ: khách duyệt giỏ rồi tự bấm thanh toán. */
  UA: "UA"
};

// src/product.types.ts
var ProductStatus = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE"
};
var AgeRestrictionType = {
  ALCOHOL: "ALCOHOL",
  TOBACCO: "TOBACCO",
  /**
   * Thuốc lá điện tử, túi nicotine (BE 14/08/2026).
   *
   * TÁCH RIÊNG khỏi `TOBACCO`, không gộp — hai nhóm này chịu quy định khác nhau
   * ở nhiều nước. Trước đây thiếu giá trị này nên vape và pouch lọt lưới hoàn
   * toàn: không khớp `TOBACCO`, rơi về `OTHER` hoặc không được đánh dấu.
   */
  NICOTINE: "NICOTINE",
  OTHER: "OTHER"
};

// src/inventory.types.ts
var StockStatus = {
  IN_STOCK: "IN_STOCK",
  LOW_STOCK: "LOW_STOCK",
  OUT_OF_STOCK: "OUT_OF_STOCK"
};
var StockAdjustmentType = {
  INCREASE: "INCREASE",
  DECREASE: "DECREASE",
  SET_ABSOLUTE: "SET_ABSOLUTE",
  DAMAGE: "DAMAGE",
  MANUAL_CORRECTION: "MANUAL_CORRECTION",
  RETURN: "RETURN",
  RESTOCK: "RESTOCK"
};
var LossReason = {
  THEFT: "THEFT",
  EXPIRED: "EXPIRED",
  DAMAGED: "DAMAGED",
  OTHER: "OTHER"
};
var StocktakeStatus = {
  OPEN: "OPEN",
  FINALIZED: "FINALIZED",
  CANCELLED: "CANCELLED"
};

// src/stock-import.types.ts
var StockImportStatus = {
  DRAFT: "DRAFT",
  SUBMITTED: "SUBMITTED",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  RECEIVING: "RECEIVING",
  COMPLETED: "COMPLETED"
};

// src/order.types.ts
var OrderChannel = {
  POS: "POS",
  MOBILE: "MOBILE",
  KIOSK: "KIOSK",
  WEB: "WEB"
};
var OrderStatus = {
  DRAFT: "DRAFT",
  CONFIRMED: "CONFIRMED",
  PREPARING: "PREPARING",
  READY: "READY",
  COMPLETED: "COMPLETED",
  PENDING_PAYMENT: "PENDING_PAYMENT",
  PAID: "PAID",
  CANCELLED: "CANCELLED",
  VOIDED: "VOIDED",
  REFUNDED: "REFUNDED",
  PARTIALLY_REFUNDED: "PARTIALLY_REFUNDED"
};

// src/payment.types.ts
var PaymentStatus = {
  PENDING: "PENDING",
  PROCESSING: "PROCESSING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  REFUNDED: "REFUNDED",
  CANCELLED: "CANCELLED"
};
var ProviderPaymentStatus = {
  PENDING: "PENDING",
  /** Đã giữ tiền (pre-auth) nhưng chưa capture. Với khách vẫn là "đang xử lý". */
  AUTHORIZED: "AUTHORIZED",
  /** Từ vựng của cổng cho "đã trả tiền" — tương đương COMPLETED. */
  PAID: "PAID",
  FAILED: "FAILED",
  /** Huỷ pre-auth trước khi capture. */
  VOIDED: "VOIDED",
  REFUNDED: "REFUNDED",
  PARTIALLY_REFUNDED: "PARTIALLY_REFUNDED"
};
function normalizePaymentStatus(status) {
  switch ((status || "").toUpperCase()) {
    case "PAID":
    case "COMPLETED":
    case "SUCCESS":
      return PaymentStatus.COMPLETED;
    case "AUTHORIZED":
    case "PROCESSING":
      return PaymentStatus.PROCESSING;
    case "FAILED":
    case "DECLINED":
    case "ERROR":
      return PaymentStatus.FAILED;
    case "VOIDED":
    case "CANCELLED":
    case "CANCELED":
    case "REVERSED":
      return PaymentStatus.CANCELLED;
    case "REFUNDED":
    case "PARTIALLY_REFUNDED":
      return PaymentStatus.REFUNDED;
    case "PENDING":
    default:
      return PaymentStatus.PENDING;
  }
}
function isSettledPaymentStatus(status) {
  const normalized = normalizePaymentStatus(status);
  return normalized === PaymentStatus.COMPLETED || normalized === PaymentStatus.FAILED || normalized === PaymentStatus.CANCELLED || normalized === PaymentStatus.REFUNDED;
}
var PaymentMethod = {
  CASH: "cash",
  CARD: "card",
  MOMO: "momo",
  VNPAY: "vnpay",
  ZALOPAY: "zalopay",
  BANK_TRANSFER: "bank_transfer",
  APPLE_PAY: "apple_pay",
  GOOGLE_PAY: "google_pay"
};
var PaymentProvider = {
  LIQPAY: "liqpay",
  WAYFORPAY: "wayforpay",
  FONDY: "fondy"
};
var POSPaymentResultStatus = {
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
  CANCELLED: "CANCELLED",
  TIMEOUT: "TIMEOUT",
  PENDING: "PENDING",
  UNKNOWN: "UNKNOWN"
};

// src/payment-mandate.types.ts
var PaymentMandateStatus = {
  /** Vừa thêm, chưa qua 3DS. Chưa dùng được. */
  PENDING: "PENDING",
  /** Đã xác minh. */
  ACTIVE: "ACTIVE",
  /**
   * Xác minh thất bại — gồm cả ca quá 15 phút không nhận được xác nhận từ PSP.
   *
   * Thẻ VẪN NẰM TRONG danh sách (BE đã xác nhận): trả về với
   * `is_chargeable: false`, `is_default: false`. Danh sách chỉ loại `REVOKED`.
   * Nên UI phải nói rõ thẻ này hỏng và cho đường đi tiếp — để nó nằm im giữa
   * các thẻ tốt là khách tưởng đã thêm xong.
   */
  FAILED: "FAILED",
  /** Khách đã xoá. Đây là trạng thái DUY NHẤT bị loại khỏi danh sách. */
  REVOKED: "REVOKED"
};
var PaymentMandateFailureReason = {
  /**
   * Khách CHƯA HOÀN TẤT bước xác thực ở ngân hàng — đóng tab, hết giờ, bấm huỷ.
   *
   * Khác hẳn "ngân hàng từ chối thẻ": thẻ vẫn tốt, thêm lại và làm hết bước
   * ngân hàng là xong. Vì thế nó đáng có câu riêng — câu chung "thẻ không dùng
   * được" đẩy khách đi tìm thẻ khác trong khi thẻ đang cầm vẫn dùng được.
   */
  AUTHENTICATION_FAILED: "authentication_failed",
  /**
   * Quá 15 phút không ai quay lại, job `expire_stale_pending` dọn định kỳ đánh
   * dấu. Khách bỏ dở giữa chừng chứ không phải ngân hàng từ chối.
   *
   * Câu cho khách: PHIÊN XÁC THỰC ĐÃ HẾT HẠN, thêm lại thẻ. Gộp vào
   * `authentication_failed` thì mất mất phần "hết hạn" — khách tưởng mình vừa
   * bấm sai ở ngân hàng và đi tìm lỗi không có.
   */
  VERIFICATION_TIMEOUT: "verification_timeout",
  /**
   * Bước 3DS không đậu. Chỉ xuất hiện ở MÔI TRƯỜNG MÔ PHỎNG — PayU thật không
   * trả mã này, nên đừng chờ thấy nó trên production.
   *
   * Câu cho khách: xác thực không thành công, thử lại hoặc dùng thẻ khác. Đây
   * là ca DUY NHẤT trong ba ca được phép gợi ý đổi thẻ.
   */
  THREE_DS_FAILED: "3ds_failed"
};
var PaymentMandateErrorReason = {
  /** 409 — đã đủ 3 thẻ. Backend trả ngay ở bước setup, không đợi nhập xong. */
  MANDATE_LIMIT_REACHED: "mandate_limit_reached",
  /**
   * 402 — PSP chưa bật đơn 0 đồng nên chưa lưu được thẻ.
   *
   * Cố ý KHÔNG có phương án tạm "trừ một khoản nhỏ rồi hoàn lại": theo tài liệu
   * PSP, tạo đơn có tiền rồi huỷ để lưu thẻ là không tuân thủ quy định tổ chức
   * thẻ. Cách đó sẽ chạy ngon trong test và đó chính là cách nó lọt lên
   * production, mang theo một vi phạm.
   */
  ZERO_AMOUNT_UNAVAILABLE: "zero_amount_unavailable",
  /** 409 — thẻ đang gắn với một lượt vào cửa hoặc phiên chưa settle xong. */
  MANDATE_IN_USE: "mandate_in_use"
};

// src/entry-intent.types.ts
var EntryIntentStatus = {
  /** Vừa tạo, chưa giữ tiền. */
  PENDING: "PENDING",
  /** Đang giữ tiền, mã QR dùng được. */
  AUTHORIZED: "AUTHORIZED",
  /** Khách đã vào cửa hàng, tiền đã nhả. */
  CONSUMED: "CONSUMED",
  /** Hết hạn không dùng, tiền đã nhả. */
  EXPIRED: "EXPIRED",
  /** Khách chủ động huỷ, tiền đã nhả. */
  VOIDED: "VOIDED",
  /** Ngân hàng từ chối. */
  DECLINED: "DECLINED"
};
var EntryIntentErrorReason = {
  /** 409 — chưa có thẻ nào. Điều hướng sang màn thêm thẻ. */
  NO_PAYMENT_METHOD: "no_payment_method",
  /** 409 — còn khoản chưa thanh toán. Điều hướng sang màn trả nợ. */
  OUTSTANDING_BALANCE: "outstanding_balance",
  /** 409 — tài khoản bị khoá. Điều hướng sang hỗ trợ. */
  ACCOUNT_BLOCKED: "account_blocked",
  /** 422 — thẻ hết hạn. Điều hướng sang màn thêm thẻ. */
  CARD_EXPIRED: "card_expired",
  /** 402 — ngân hàng từ chối. Gợi ý dùng thẻ khác. */
  PREAUTH_DECLINED: "preauth_declined",
  /** 409 — khách đã quét mã vào cửa rồi, không huỷ được nữa (chỉ ở DELETE). */
  ENTRY_ALREADY_USED: "entry_already_used"
};

// src/customer.types.ts
var CustomerGender = {
  MALE: "MALE",
  FEMALE: "FEMALE",
  OTHER: "OTHER"
};
var AgeVerificationStatus = {
  UNVERIFIED: "UNVERIFIED",
  PENDING: "PENDING",
  VERIFIED: "VERIFIED",
  /**
   * CHỈ do người duyệt đặt. Đường MRZ không bao giờ tự từ chối.
   *
   * Lý do (BE 18/08/2026): lỗi đọc từ 2 ký tự trở lên vẫn có ~10% lọt qua chữ
   * số kiểm tra, nên một chuỗi "sạch" vẫn có thể sai ngày sinh. Từ chối nhầm
   * thì khách phải làm lại từ đầu, đổi lấy vài giây tiết kiệm cho người duyệt
   * trên một loại hồ sơ hiếm — không đáng.
   *
   * Hệ quả cho client: máy chỉ có hai đường ra, `VERIFIED` hoặc `PENDING`.
   * Đừng dựng nhánh UI cho ca "máy từ chối".
   */
  REJECTED: "REJECTED"
};
var AgeVerificationMethod = {
  /** Дія — ứng dụng định danh điện tử của Ukraine. Chỉ market UA. */
  DIIA: "DIIA",
  /**
   * mDowód trong ứng dụng mObywatel (Ba Lan).
   *
   * KHAI BÁO SẴN NHƯNG BACKEND CHƯA TRẢ VỀ. Luật Ba Lan yêu cầu người bán quét
   * mã QR do mObywatel sinh ra rồi đối chiếu — luồng hiện tại là khách tự chụp
   * ảnh giấy tờ và admin duyệt bằng mắt, đủ chuẩn cho PASSPORT / ID_CARD /
   * DRIVING_LICENSE nhưng KHÔNG đúng chuẩn mDowód. Bật lại sau khi làm luồng
   * quét QR đối chiếu.
   */
  MDOWOD: "MDOWOD",
  PASSPORT: "PASSPORT",
  ID_CARD: "ID_CARD",
  /** Bằng lái xe — giấy tờ hợp lệ để xác minh tuổi ở Ba Lan. */
  DRIVING_LICENSE: "DRIVING_LICENSE"
};
var AgeVerificationRequiredMethod = {
  /** Đọc chip qua NFC (e-dowód). Market PL chỉ nhận cái này. */
  DOCUMENT_CHIP: "DOCUMENT_CHIP",
  /** Quét MRZ bằng camera. Luồng cũ, các thị trường còn lại. */
  DOCUMENT_MRZ: "DOCUMENT_MRZ"
};
function needsReverificationForStore(verification) {
  if (!verification) return false;
  if (verification.status !== AgeVerificationStatus.VERIFIED) return false;
  return verification.satisfies_current_store === false;
}
var AgeVerificationFailureReason = {
  /**
   * Chuỗi MRZ sai cấu trúc hoặc chữ số kiểm tra không khớp.
   *
   * Gộp hai ca là cố ý: với khách thì cả hai đều là "máy không đọc được".
   * Đây là mã DUY NHẤT mà chụp lại cứu được.
   */
  MRZ_UNREADABLE: "mrz_unreadable",
  /** Đọc sạch nhưng giấy tờ đã hết hạn. Chụp lại không làm thẻ còn hạn. */
  MRZ_DOCUMENT_EXPIRED: "mrz_document_expired",
  /** Đọc sạch nhưng chưa đủ tuổi. Chụp lại không làm người ta già đi. */
  MRZ_UNDERAGE: "mrz_underage",
  /** Không gửi MRZ: bản web, giấy tờ không có vùng MRZ, hoặc bản app cũ. */
  NO_MRZ: "no_mrz"
};
function readFailureReason(verification) {
  return (verification?.failure_reason ?? "").trim().toLowerCase();
}
function isRetakeUseful(verification) {
  if (typeof verification?.can_retry === "boolean") return verification.can_retry;
  return readFailureReason(verification) === AgeVerificationFailureReason.MRZ_UNREADABLE;
}

// src/loyalty.types.ts
var LoyaltyTier = {
  BRONZE: "BRONZE",
  SILVER: "SILVER",
  GOLD: "GOLD",
  PLATINUM: "PLATINUM"
};
var LoyaltyEntryType = {
  EARN: "EARN",
  REDEEM: "REDEEM",
  ADJUST: "ADJUST",
  EXPIRE: "EXPIRE",
  BONUS: "BONUS"
};

// src/access-control.types.ts
var AccessMethod = {
  QR_CODE: "QR_CODE",
  NFC: "NFC",
  FACE_RECOGNITION: "FACE_RECOGNITION",
  MANUAL: "MANUAL"
};
var AccessResult = {
  SUCCESS: "SUCCESS",
  DENIED: "DENIED",
  EXPIRED: "EXPIRED",
  INVALID: "INVALID"
};

// src/atwork.types.ts
var AtWorkCommandSource = {
  ADMIN_WEB: "ADMIN_WEB",
  MOBILE_APP: "MOBILE_APP",
  AI: "AI",
  SYSTEM: "SYSTEM"
};
var AtWorkCommandStatus = {
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED"
};
var AtWorkErrorCode = {
  NEDAP_INVALID_DOOR_ID: "NEDAP_INVALID_DOOR_ID",
  NEDAP_AUTHORIZATION_DENIED: "NEDAP_AUTHORIZATION_DENIED",
  NEDAP_DOOR_NOT_EXISTS: "NEDAP_DOOR_NOT_EXISTS",
  NEDAP_PROVIDE_ACCESS_DISABLED: "NEDAP_PROVIDE_ACCESS_DISABLED",
  NEDAP_RETURNED_FALSE: "NEDAP_RETURNED_FALSE",
  NEDAP_PROVIDE_ACCESS_FAILED: "NEDAP_PROVIDE_ACCESS_FAILED"
};

// src/promotion.types.ts
var PromotionType = {
  COUPON: "COUPON",
  AUTOMATIC: "AUTOMATIC",
  FLASH_SALE: "FLASH_SALE",
  LOYALTY: "LOYALTY"
};
var PromotionStatus = {
  DRAFT: "DRAFT",
  ACTIVE: "ACTIVE",
  PAUSED: "PAUSED",
  EXPIRED: "EXPIRED",
  CANCELLED: "CANCELLED"
};
var DiscountType = {
  PERCENTAGE: "percentage",
  FIXED: "fixed"
};

// src/receipt.types.ts
var AuditAction = {
  CREATE: "CREATE",
  UPDATE: "UPDATE",
  DELETE: "DELETE",
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  ACCESS: "ACCESS",
  APPROVE: "APPROVE",
  CANCEL: "CANCEL",
  REFUND: "REFUND",
  VOID: "VOID",
  ADJUST: "ADJUST",
  COMPLETE: "COMPLETE",
  PASSWORD_CHANGE: "PASSWORD_CHANGE",
  PASSWORD_RESET: "PASSWORD_RESET",
  ACCOUNT_DELETION: "ACCOUNT_DELETION"
};

// src/session.types.ts
var SessionStatus = {
  /** Khách đang trong cửa hàng, sản phẩm còn thay đổi. */
  OPEN: "OPEN",
  /** Khách đã bấm "Review & approve", chờ thanh toán. */
  AWAITING_APPROVAL: "AWAITING_APPROVAL",
  /** Đã phê duyệt, đang xử lý thanh toán. Chỉ market UA. */
  PAYING: "PAYING",
  /**
   * Đang trừ tiền ở cổng ra. Chỉ market PL.
   *
   * Đóng đúng vai `PAYING` của luồng UA, khác ở chỗ hệ thống tự trừ chứ khách
   * không bấm gì. Khách vẫn đang ĐỨNG TRONG cửa hàng chờ cửa mở, nên đây là
   * trạng thái SỐNG — xem `LIVE_STATUSES`.
   *
   * Trừ thất bại thì quay lại `OPEN` (khách bỏ món ra hoặc đổi thẻ rồi thử
   * lại). `SETTLING -> OPEN` là chuyển hợp lệ, không phải lỗi.
   */
  SETTLING: "SETTLING",
  /** Đã thanh toán — cửa ra được mở, khách còn trong cửa hàng. */
  PAID: "PAID",
  /** Khách đã ra khỏi cửa hàng. Phiên đóng, chỉ còn xem lại. */
  EXITED: "EXITED",
  /** Khách chủ động huỷ, không mua gì. */
  CANCELLED: "CANCELLED",
  /**
   * Khách rời cửa hàng với giỏ chưa thanh toán.
   *
   * KHÔNG gộp với `CANCELLED`: backend ghi log `COMPLIANCE:` cho trường hợp này
   * và bộ phận vận hành cần phân biệt được. Chỉ phần *hiển thị cho khách* mới
   * dùng chung giao diện trung tính với `CANCELLED`.
   */
  ABANDONED: "ABANDONED",
  /**
   * Khách vào rồi ra tay không. Chỉ market PL.
   *
   * Giỏ rỗng nên cửa mở luôn, không đụng tới cổng thanh toán. Đây cũng là
   * ĐƯỜNG THOÁT khi trừ tiền thất bại: khách bỏ hết đồ lại, cảm biến trừ dần
   * giỏ, giỏ rỗng thì cửa mở. Không ai bị giữ lại trong cửa hàng vì thẻ hỏng.
   *
   * Hiển thị trung tính như `CANCELLED` — khách không mua gì không phải lỗi.
   */
  CLOSED_NO_PURCHASE: "CLOSED_NO_PURCHASE"
};
var DisputeBlockedReason = {
  /** Phiên chưa trừ tiền xong — chưa có gì để khiếu nại. */
  SESSION_NOT_SETTLED: "session_not_settled",
  /** Quá hạn khiếu nại. Hạn gắn với chính sách lưu footage, do backend quyết. */
  DISPUTE_WINDOW_CLOSED: "dispute_window_closed",
  /** Dòng này đã khiếu nại rồi — mỗi dòng chỉ một lần. */
  ALREADY_DISPUTED: "already_disputed",
  /**
   * Dòng lịch sử cũ không có liên kết về đơn nên không khiếu nại được.
   *
   * CHỈ xuất hiện ở màn lịch sử giao dịch, không bao giờ ở hoá đơn phiên. Cần
   * mã riêng vì không mã nào khác nói đúng lý do — bảo khách "hết hạn" hay "đã
   * khiếu nại" trong khi thực ra dữ liệu cũ thiếu liên kết là nói dối.
   */
  LINE_NOT_LINKED: "line_not_linked"
};
var SalesBlockedReason = {
  /** Xác minh tuổi xong là mua được. KHẮC PHỤC ĐƯỢC. */
  AGE_VERIFICATION_REQUIRED: "age_verification_required",
  /** Qua giờ cấm là mua được. KHẮC PHỤC ĐƯỢC (chỉ cần chờ). */
  ALCOHOL_CURFEW_ACTIVE: "alcohol_curfew_active",
  /**
   * Cửa hàng tự phục vụ không được bán nhóm hàng này (thuốc lá, e-thuốc lá,
   * túi nicotine ở PL). KHÔNG khắc phục được.
   */
  PRODUCT_NOT_SELLABLE_IN_FORMAT: "product_not_sellable_in_format",
  /**
   * Rượu trên 4,5% và không phải bia. KHÔNG khắc phục được.
   *
   * Nồng độ chưa biết (`alcohol_by_volume = null`) cũng rơi vào đây — backend
   * coi chưa khai là quá mạnh.
   */
  ALCOHOL_TOO_STRONG_FOR_FORMAT: "alcohol_too_strong_for_format"
};
function isBlockedReasonRecoverable(reason) {
  const code = (reason ?? "").toLowerCase();
  return code === SalesBlockedReason.AGE_VERIFICATION_REQUIRED || code === SalesBlockedReason.ALCOHOL_CURFEW_ACTIVE;
}
var SessionSettlementFailureReason = {
  /** Ngân hàng từ chối. Đổi thẻ rồi thử lại. */
  CARD_DECLINED: "card_declined",
  /**
   * Không còn thẻ nào dùng được (thẻ bị xoá giữa phiên, hoặc chưa từng có).
   *
   * Tách riêng khỏi `CARD_DECLINED` vì hướng xử lý khác hẳn: ở đây nút phải là
   * "thêm thẻ", không phải "dùng thẻ khác" — bảo khách dùng thẻ khác trong khi
   * họ không còn thẻ nào là hướng dẫn vào ngõ cụt.
   */
  NO_CHARGEABLE_CARD: "no_chargeable_card",
  /**
   * ⚠️ KHÔNG BAO GIỜ XUẤT HIỆN Ở CỔNG RA (backend xác nhận 14/08/2026).
   *
   * Thẻ hết hạn thì không còn gì trừ được, nên ở cổng ra nó rơi vào
   * `NO_CHARGEABLE_CARD`. Mã này chỉ dùng cho luồng bị từ chối VÀO cửa — xem
   * push `entry.denied`.
   *
   * Giữ trong enum để không vỡ nếu backend đổi ý, nhưng **màn cổng ra chỉ cần
   * 7 biến thể**, đừng dựng biến thể thứ tám không ai thấy bao giờ.
   */
  CARD_EXPIRED: "card_expired",
  /**
   * Ngân hàng đòi xác thực 3DS trên giao dịch tự động.
   *
   * Không có khách thao tác ở thời điểm trừ tiền nên coi như từ chối. Hiển thị
   * "dùng thẻ khác" — đừng hiện gì về 3DS, khách không làm được gì với thông
   * tin đó.
   */
  AUTHENTICATION_REQUIRED: "authentication_required",
  /** Giỏ có món 18+ mà khách chưa xác minh tuổi. Xem `blocking_items`. */
  AGE_VERIFICATION_REQUIRED: "age_verification_required",
  /** Giỏ có rượu trong giờ cấm bán. Chặn kể cả khách đã xác minh. */
  ALCOHOL_CURFEW_ACTIVE: "alcohol_curfew_active",
  /**
   * Giỏ có nhóm hàng cửa hàng tự phục vụ không được bán (PL, 17/08/2026).
   *
   * Không chờ được, không xác minh được — lối ra duy nhất là bỏ món ra. Xem
   * `SalesBlockedReason`.
   */
  PRODUCT_NOT_SELLABLE_IN_FORMAT: "product_not_sellable_in_format",
  /** Giỏ có rượu trên 4,5% và không phải bia (PL, 17/08/2026). Không khắc phục được. */
  ALCOHOL_TOO_STRONG_FOR_FORMAT: "alcohol_too_strong_for_format",
  /** Hết số lần thử cho phép. */
  MAX_ATTEMPTS_REACHED: "max_attempts_reached",
  /** Cổng thanh toán không trả lời kịp. Chưa chắc thất bại — cho thử lại. */
  GATEWAY_TIMEOUT: "gateway_timeout"
};
var SessionItemChange = {
  PRICE_CHANGED: "PRICE_CHANGED",
  /** Cảm biến thêm món sau khi khách mở màn duyệt. */
  ADDED: "ADDED",
  /** Món biến mất khỏi giỏ (khách đặt lại kệ). */
  REMOVED: "REMOVED",
  /** Khuyến mãi hết hiệu lực giữa chừng. */
  PROMOTION_EXPIRED: "PROMOTION_EXPIRED"
};

// src/dispute.types.ts
var DisputeReason = {
  /** Bị tính món không lấy, hoặc đếm thừa số lượng. */
  NOT_TAKEN: "NOT_TAKEN",
  /** Hàng lỗi, hết hạn. */
  DEFECTIVE: "DEFECTIVE",
  /** Giá tính khác giá niêm yết trên kệ. */
  PRICE_MISMATCH: "PRICE_MISMATCH",
  OTHER: "OTHER"
};
var DisputeStatus = {
  /** Chờ nhân viên xem. Máy KHÔNG BAO GIỜ tự từ chối — chỉ đồng ý hoặc để người xem. */
  PENDING_REVIEW: "PENDING_REVIEW",
  APPROVED: "APPROVED",
  PARTIALLY_APPROVED: "PARTIALLY_APPROVED",
  REJECTED: "REJECTED"
};

// src/return.types.ts
var ReturnReason = {
  DAMAGED_PACKAGING: "DAMAGED_PACKAGING",
  EXPIRED: "EXPIRED",
  WRONG_ITEM: "WRONG_ITEM",
  QUALITY_ISSUE: "QUALITY_ISSUE",
  CHANGED_MIND: "CHANGED_MIND",
  OTHER: "OTHER"
};
var ReturnStatus = {
  /** Vừa tạo, chờ chính sách quyết định tự duyệt hay đẩy lên admin. */
  CREATED: "CREATED",
  /** Chờ quản trị duyệt (khi chính sách không cho tự động). */
  PENDING_APPROVAL: "PENDING_APPROVAL",
  /**
   * Đã được duyệt — khách được mang hàng tới quầy.
   *
   * Chỉ từ trạng thái này trở đi `can_bring_items` mới là true.
   */
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  /** Nhân viên đã quét QR và nhận hàng. */
  ITEMS_RECEIVED: "ITEMS_RECEIVED",
  /** Đã gửi lệnh hoàn tiền sang cổng thanh toán. */
  REFUND_SENT: "REFUND_SENT",
  /** Tiền đã về thẻ khách. */
  REFUNDED: "REFUNDED",
  CANCELLED: "CANCELLED",
  EXPIRED: "EXPIRED"
};
var ReturnTimelineStep = {
  REQUEST_CREATED: "REQUEST_CREATED",
  ITEMS_CHECKED: "ITEMS_CHECKED",
  REFUND_SENT: "REFUND_SENT",
  MONEY_BACK: "MONEY_BACK"
};

// src/feedback.types.ts
var FeedbackType = {
  STORE_EXPERIENCE: "STORE_EXPERIENCE",
  PRODUCT_ISSUE: "PRODUCT_ISSUE",
  APP_ISSUE: "APP_ISSUE",
  OTHER: "OTHER"
};
var IssueKind = {
  EXPIRED: "EXPIRED",
  DAMAGED_PACKAGING: "DAMAGED_PACKAGING",
  QUALITY_ISSUE: "QUALITY_ISSUE",
  WRONG_PRICE: "WRONG_PRICE",
  MISSING_FROM_SHELF: "MISSING_FROM_SHELF",
  OTHER: "OTHER"
};
var FeedbackStatus = {
  NEW: "NEW",
  IN_REVIEW: "IN_REVIEW",
  RESOLVED: "RESOLVED",
  DISMISSED: "DISMISSED"
};
var FEEDBACK_RATING_VALUES = [1, 2, 3, 4, 5];
var STAFF_FEEDBACK_MAX_PAGE_SIZE = 100;

// src/restricted-sales.types.ts
function isYes(value) {
  return (value ?? "").trim().toLowerCase() === "yes";
}
var RESTRICTED_SALES_DEFAULT_DAYS = 90;
var RESTRICTED_SALES_MAX_RANGE_DAYS = 400;
function restrictedSalesRangeDays(startDate, endDate) {
  if (!startDate || !endDate) return null;
  const start = Date.parse(`${startDate}T00:00:00Z`);
  const end = Date.parse(`${endDate}T00:00:00Z`);
  if (Number.isNaN(start) || Number.isNaN(end)) return null;
  return Math.floor((end - start) / 864e5) + 1;
}
export {
  AccessMethod,
  AccessResult,
  AgeRestrictionType,
  AgeVerificationFailureReason,
  AgeVerificationMethod,
  AgeVerificationRequiredMethod,
  AgeVerificationStatus,
  AtWorkCommandSource,
  AtWorkCommandStatus,
  AtWorkErrorCode,
  AuditAction,
  CustomerGender,
  DiscountType,
  DisputeBlockedReason,
  DisputeReason,
  DisputeStatus,
  EntryIntentErrorReason,
  EntryIntentStatus,
  FEEDBACK_RATING_VALUES,
  FeedbackStatus,
  FeedbackType,
  IssueKind,
  LossReason,
  LoyaltyEntryType,
  LoyaltyTier,
  Market,
  OrderChannel,
  OrderStatus,
  POSPaymentResultStatus,
  PaymentMandateErrorReason,
  PaymentMandateFailureReason,
  PaymentMandateStatus,
  PaymentMethod,
  PaymentProvider,
  PaymentStatus,
  ProductStatus,
  PromotionStatus,
  PromotionType,
  ProviderPaymentStatus,
  RESTRICTED_SALES_DEFAULT_DAYS,
  RESTRICTED_SALES_MAX_RANGE_DAYS,
  ReturnReason,
  ReturnStatus,
  ReturnTimelineStep,
  STAFF_FEEDBACK_MAX_PAGE_SIZE,
  SalesBlockedReason,
  SessionItemChange,
  SessionSettlementFailureReason,
  SessionStatus,
  StockAdjustmentType,
  StockImportStatus,
  StockStatus,
  StocktakeStatus,
  StoreStatus,
  UserRole,
  isAdminTwoFactorChallenge,
  isBlockedReasonRecoverable,
  isRetakeUseful,
  isSettledPaymentStatus,
  isTwoFactorChallenge,
  isYes,
  needsReverificationForStore,
  normalizePaymentStatus,
  readFailureReason,
  restrictedSalesRangeDays
};
